// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactionTabs__container-c21a69 {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0px 16px 4px 16px;
  padding: 8px 0px;
  overflow-x: auto;
  overflow-y: hidden;
  max-width: 440px;
}

.ReactionTabs__tab-eef5ba {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-inline-start: 8px;
  padding-inline-end: 12px;
  margin-inline-end: 8px;
  border-radius: 8px;
  color: var(--base-80);
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  cursor: pointer;
}

.ReactionTabs__tab-eef5ba:hover,
.ReactionTabs__tab-eef5ba:focus-visible {
  background-color: var(--base-20);
  color: var(--base-110);
}

.ReactionTabs__tab-eef5ba:active {
  background-color: var(--base-30);
  color: var(--base-110);
}

.ReactionTabs__tab-eef5ba:last-child {
  margin-inline-end: 0;
}

.ReactionTabs__tab-eef5ba.ReactionTabs__button-b859e9 {
  padding: 6px 8px;
}

.ReactionTabs__tab-eef5ba.ReactionTabs__active-ab262d {
  background-color: var(--base-20);
  color: var(--base-110);
}

.ReactionTabs__image-f4b49e {
  width: 24px;
  height: 24px;
  margin-inline-end: 6px;
}`, "",{"version":3,"sources":["webpack://./src/main/PopupManager/Popups/ReactionsDetailedPopup/ReactionTabs/ReactionTabs.style.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,wBAAA;EACA,sBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,eAAA;AACF;;AAEA;;EAEE,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,gCAAA;EACA,sBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0px 16px 4px 16px;\n  padding: 8px 0px;\n  overflow-x: auto;\n  overflow-y: hidden;\n  max-width: 440px;\n}\n\n.tab {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 6px;\n  padding-bottom: 6px;\n  padding-inline-start: 8px;\n  padding-inline-end: 12px;\n  margin-inline-end: 8px;\n  border-radius: 8px;\n  color: var(--base-80);\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  cursor: pointer;\n}\n\n.tab:hover,\n.tab:focus-visible {\n  background-color: var(--base-20);\n  color: var(--base-110);\n}\n\n.tab:active {\n  background-color: var(--base-30);\n  color: var(--base-110);\n}\n\n.tab:last-child {\n  margin-inline-end: 0;\n}\n\n.tab.button {\n  padding: 6px 8px;\n}\n\n.tab.active {\n  background-color: var(--base-20);\n  color: var(--base-110);\n}\n\n.image {\n  width: 24px;\n  height: 24px;\n  margin-inline-end: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ReactionTabs__container-c21a69`,
	"tab": `ReactionTabs__tab-eef5ba`,
	"button": `ReactionTabs__button-b859e9`,
	"active": `ReactionTabs__active-ab262d`,
	"image": `ReactionTabs__image-f4b49e`
};
module.exports = ___CSS_LOADER_EXPORT___;
